import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="bg-surface-1 border-y border-white/5 py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl mx-auto text-center">
          {/* Decorative line */}
          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="h-px flex-1 bg-white/5" />
            <div className="w-2 h-2 rounded-full bg-gold" />
            <div className="h-px flex-1 bg-white/5" />
          </div>

          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-white leading-tight mb-6">
            Ready to Start Building<br />
            <span className="text-gold">Your Certificate Portfolio?</span>
          </h2>
          <p className="text-white/45 text-lg mb-10 max-w-xl mx-auto">
            Join 1,200+ members who trust our specialists to acquire tax lien and foreclosure certificates across the United States — completely on their behalf.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <Link
              to="/pricing"
              className="inline-flex items-center gap-2 px-10 py-4 bg-gold text-navy-dark font-bold rounded-xl hover:bg-gold-light transition-colors whitespace-nowrap text-lg"
            >
              View Service Plans
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/how-it-works"
              className="inline-flex items-center gap-2 px-10 py-4 border border-white/15 text-white/65 font-semibold rounded-xl hover:border-white/30 hover:text-white transition-colors whitespace-nowrap text-base"
            >
              How It Works
            </Link>
          </div>

          <p className="text-white/25 text-sm">
            14-day free trial &nbsp;·&nbsp; No credit card required &nbsp;·&nbsp; Cancel anytime
          </p>
        </div>
      </div>
    </section>
  );
}
